import React, { useState } from "react";
import SearchIcon from "../../assets/svg/SearchIcon.svg";
import Add from "../../assets/svg/Add.svg";
import Completed from "../../assets/svg/Completed.svg";
import Cancelled from "../../assets/svg/cancelled.icon.svg";
import Arrow from "../../assets/svg/Arrow.svg";
import commentOrder from "../../assets/svg/commentOrder.svg";
import audit_EdetOrederCliantes from "../../assets/svg/audit_EdetOrederCliantes.svg";
import pen_edete from "../../assets/svg/pen_edete.svg";
import helpRequest from "../../assets/svg/helpRequest.icon.svg";
import icontoUserVe from "../../assets/svg/icontoUserVe.svg";
import "./Clients.css"; // Ensure the correct CSS file is imported
import { Modal } from "react-bootstrap";

const orders = [
  {
    id: 210,
    vehicle: "Volkswagen IDA Pro S",
    version: " July 11.2024 02:30 pm",
    requestedDate: "July 14.2024",
    paymentMethod: "Cash",
    time: "09:00 am - 12:00 pm",
    location: "383R+QQG, 4450301",
    services: [
      { name: "Oil Services", price: 200.0 },
      { name: "Oil Leak", price: 100.0 },
      { name: "Check Engine oil", price: 850.0 },
      { name: "Change Oil", price: 200.0 },
      { name: "Detect holes", price: 100.0 },
      { name: "Nitrogen filling", price: 100.0 },
    ],
    oilDetails: {
      brand: "Shell",
      viscosity: "SW-30",
      liters: "3L",
      filter: "Help request",
    },
    total: 1450.0,
    status: "completed",
    details:
      "The client requested a car wash and interior detailing service, which was completed successfully.",
  },
  {
    id: 186,
    vehicle: "Volkswagen IDA Pro S",
    version: " July 11.2024 02:30 pm",
    requestedDate: "July 14.2024",
    paymentMethod: "Cash",
    time: "09:00 am - 12:00 pm",
    location: "383R+QQG, 4450301",

    oilDetails: {
      brand: "Shell",
      viscosity: "SW-30",
      liters: "3L",
      filter: "Help request",
    },
    total: 1450.0,
    status: "completed",
    details:
      "The client had a scheduled maintenance checkup, including oil change and brake pad inspection.",
  },
  {
    id: 145,
    vehicle: "Volkswagen IDA Pro S",
    version: "July 11.2024 02:30 pm",
    requestedDate: "July 14.2024",
    paymentMethod: "Cash",
    time: "09:00 am - 12:00 pm",
    location: "383R+QQG, 4450301",
    oilDetails: {
      brand: "Shell",
      viscosity: "SW-30",
      liters: "3L",
      filter: "Help request",
    },
    total: 1450.0,
    status: "cancelled",
    details:
      "The client requested an oil filter check and battery change service, but the client cancelled the order.",
  },
  {
    id: 113,
    vehicle: "Volkswagen IDA Pro S",
    version: "July 11.2024 02:30 pm",
    requestedDate: "July 14.2024",
    paymentMethod: "Cash",
    time: "09:00 am - 12:00 pm",
    location: "383R+QQG, 4450301",
    oilDetails: {
      brand: "Shell",
      viscosity: "SW-30",
      liters: "3L",
      filter: "Help request",
    },
    total: 1450.0,
    status: "completed",
    details:
      "The client required a tire rotation and alignment service, which was completed without issues.",
  },
  {
    id: 98,
    vehicle: "Volkswagen IDA Pro S",
    version: " July 11.2024 02:30 pm",
    requestedDate: "July 14.2024",
    paymentMethod: "Cash",
    time: "09:00 am - 12:00 pm",
    location: "383R+QQG, 4450301",
    oilDetails: {
      brand: "Shell",
      viscosity: "SW-30",
      liters: "3L",
      filter: "Help request",
    },
    total: 1450.0,
    status: "completed",
    details:
      "A full car diagnostic was performed, identifying minor engine tuning requirements, which were resolved.",
  },
  {
    id: 56,
    vehicle: "Volkswagen IDA Pro S",
    version: " July 11.2024 02:30 pm",
    requestedDate: "July 14.2024",
    paymentMethod: "Cash",
    time: "09:00 am - 12:00 pm",
    location: "383R+QQG, 4450301",
    oilDetails: {
      brand: "Shell",
      viscosity: "SW-30",
      liters: "3L",
      filter: "Help request",
    },
    total: 1450.0,
    status: "cancelled",
    details:
      "The client booked a headlight restoration service but decided to cancel before the service date.",
  },
  {
    id: 12,
    vehicle: "Volkswagen IDA Pro S",
    version: " July 11.2024 02:30 pm",
    requestedDate: "July 14.2024",
    paymentMethod: "Cash",
    time: "09:00 am - 12:00 pm",
    location: "383R+QQG, 4450301",
    oilDetails: {
      brand: "Shell",
      viscosity: "SW-30",
      liters: "3L",
      filter: "Help request",
    },
    total: 1450.0,
    status: "completed",
    details:
      "The client requested an oil change and tire change service, which were already performed.",
  },
];

export default function Orders_Clientinfo() {
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedOrderId, setExpandedOrderId] = useState(null);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const toggleOrderDetails = (orderId) => {
    setExpandedOrderId(expandedOrderId === orderId ? null : orderId);
  };
  const [show, setShow] = useState(false);
  const [oerderView, SetOerderView] = useState(false);
  const Close = () => setShow(false);
  const open = (order) => {
    SetOerderView(order);
    setShow(true);
  };
  const divStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };

  return (
    <>
      <Modal
        contentClassName="Roles-content"
        dialogClassName="Roles-dialog"
        show={show}
        onHide={Close}
      >
        <Modal.Header className="AddStaffModal_header">
          <Modal.Title className="Oerder-request_main">
            <span className="Oerder-request">
              Order <span>#{oerderView.id}</span>
            </span>
            <span className="help-request">
              <img src={helpRequest} alt="" />
              Help request
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={divStyle}>
          <div className="vehicle-info">
            <div className="info_info">
              <img src={icontoUserVe} alt="" />
              <div className="info_info_info">
                <span>{oerderView?.vehicle}</span>
                <span>2021</span>
              </div>
            </div>
            <div className="mainmiaui">
              <p>
                Version 1: <span>{oerderView?.version}</span>
              </p>
              <div className="">
                <img src={Arrow} className="boint_lift" alt="" />
                <img src={Arrow} className="boient_right" alt="" />
              </div>
            </div>
          </div>
          <div className="request-info">
            <div>
              <p>
                <span>Requested Date:</span> {oerderView?.requestedDate}
              </p>
              <p>
                <span>Payment:</span> {oerderView?.paymentMethod}
              </p>
            </div>
            <div>
              <p>
                <span>Time:</span> {oerderView?.time}
              </p>
              <p>
                <span>Location:</span> {oerderView?.location}
              </p>
            </div>
          </div>
          <div className="title_requesat_Sle">
            <span className="title_requesat_Sle_1">Services</span>
            <span>Price</span>
          </div>
          <div className="body_requesat_Sle">
            <div className="tilte_body_requesat_Sle">Oil Services</div>
            <div>
              <span className="title_requesat_Sle_1">Oil Leak</span>
              <span>200.0 $</span>
            </div>
            <div>
              <span className="title_requesat_Sle_1">Check Engine oil</span>
              <span>100.0 $</span>
            </div>
            <div>
              <span className="title_requesat_Sle_1">Change Oil</span>
              <span>850.0 $</span>
            </div>
            <div className="all_body_requesat_Sle">
              <span>
                Oil Brand: <span>{oerderView?.oilDetails?.brand}</span>
              </span>
              <span>
                Oil Viscosity:
                <span>{oerderView?.oilDetails?.viscosity}</span>
              </span>
              <span>
                Oil Liters: <span>{oerderView?.oilDetails?.liters}</span>
              </span>
              <span>
                Oil Filter: <span>{oerderView?.oilDetails?.filter}</span>
              </span>
            </div>
          </div>
          <div className="body_requesat_Sle">
            <div className="tilte_body_requesat_Sle">Tire Services</div>
            <div>
              <span className="title_requesat_Sle_1">Detect holes</span>
              <span>200.0 $</span>
            </div>
            <div>
              <span className="title_requesat_Sle_1">Nitrogen filling</span>
              <span>100.0 $</span>
            </div>
          </div>
          <div className="total-section">
            <h3>Total:</h3>
            <p>${oerderView?.total?.toFixed(2)}</p>
          </div>
        </Modal.Body>
      </Modal>
      <div className="Vehicles_clientifo_header">
        <div className="StockPage-serchBar">
          <input
            type="text"
            placeholder="Search... "
            value={searchTerm}
            className="serchAndFilter-input_Stock"
            onChange={handleSearchChange}
          />
          <img
            src={SearchIcon}
            className="serchAndFilter-icon_Stock"
            alt="Search"
          />
        </div>
        <div className="stockPage_titleAndAdd">
          <div className="stockPage_add">
            <img className="stockPage_add_img" src={Add} alt="Add" />
            <div className="stockPage_add_text">Add New Item</div>
          </div>
        </div>
      </div>
      <div className="timeline-container">
        <div className="timeline">
          {orders
            ?.filter((e) => e.id.toString().includes(searchTerm))
            .map((order) => (
              <div key={order.id} className="timeline-item">
                <span className={`timeline-icon`}>
                  {order.status === "completed" ? (
                    <img src={Completed} alt="Completed" />
                  ) : (
                    <img src={Cancelled} alt="Cancelled" />
                  )}
                </span>
                <div className="timeline-content">
                  <button
                    onClick={() => toggleOrderDetails(order.id)}
                    className="order-title"
                  >
                    Order # {order.id}
                    <span className="arrow">
                      <img
                        className={
                          expandedOrderId === order.id
                            ? "ArrDown_Open"
                            : "ArrDown_Close"
                        }
                        src={Arrow}
                        alt="Arrow"
                      />
                    </span>
                  </button>
                  <div
                    className={`order-details ${
                      expandedOrderId === order.id ? "open" : ""
                    }`}
                  >
                    <p>{order.details}</p>
                    <div className="order-meta">
                      <span className="order-date">Mon 08/5/2024 01:30 PM</span>
                      <span className="order-date">
                        <img src={commentOrder} alt="" />
                      </span>
                      <span className="order-date">
                        <img src={pen_edete} alt="" />
                      </span>
                    </div>
                    <span
                      onClick={() => open(order)}
                      className="order-date_audit_EdetOrederCliantes"
                    >
                      <img src={audit_EdetOrederCliantes} alt="" />
                    </span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
